import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { IChargeNumberManagement } from '../../contract-management/IChargeNumberManagement';
import * as fromDataServices from '../../data-services';
import { FeeLevel } from '../../data-services/fee-level/fee-level.model';
import * as fromLookups from '../../lookups';
import { Process } from '../../shared';
import { columnResize } from '../../shared/columnResize';
import { SelectItem, Table } from '../../shared/efaact-primeng.module';
import { DisplayErrors } from '../../shared/errors-sidenav';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromUser from '../../user-info';

@Component({
    selector: 'ef-fee-level-presenter',
    templateUrl: './fee-level-presenter.component.html',
    styleUrls: ['./fee-level-presenter.component.scss'],
    standalone: false
})
export class FeeLevelPresenterComponent
    extends DisplayErrors<FeeLevel>
    implements OnInit, AfterViewInit, OnDestroy
{
    private FeeLevelSubject = new ReplaySubject<Array<FeeLevel>>(1);
    private _feelevels: Array<FeeLevel>;
    today: Date;
    minDate: Date;
    feeHistTabHeight: string;
    feeHistContainerHeight: string;
    feeLevelTabHeight: string;
    feeLevelContainerHeight: string;
    contractChanged: boolean = false;
    oldSelectedContract: any;
    @Input() set feeLevels(value: Array<FeeLevel>) {
        this._feelevels = value;
        if (this._feelevels.some(x => x.ChargeNumber != null) == true) {
            this.log.verbose('there are charge numbers');
            this.AreCns = true;
            this.colspan = 4;
        } else {
            this.log.verbose('there are not charge numbers');
            this.AreCns = false;
            this.colspan = 3;
        }
        this.FeeLevelSubject.next(value);

        this.cFilterSelectItem = value.map(x => ({
            value: x.ContractListID,
            label: x.ContractDesc
        }));
        this.cFilterSelectItem = this.cFilterSelectItem.filter(
            (v, i, a) => a.findIndex(t => t.label === v.label) === i
        );
        this.cnFilterSelectItem = value.map(x => ({
            value: x.CNListID,
            label: x.ChargeNumber
        }));
        this.cnFilterSelectItem = this.cnFilterSelectItem.filter(
            (v, i, a) => a.findIndex(t => t.label === v.label) === i
        );
        this.ctFilterSelectItem = value.map(x => ({
            value: x.ContractType,
            label: x.ContractType
        }));
        this.ctFilterSelectItem = this.ctFilterSelectItem.filter(
            (v, i, a) => a.findIndex(t => t.label === v.label) === i
        );
        setTimeout(() => {
            if (this.IsAddClicked === true) {
                const row = document.getElementById(
                    `row-${
                        this._feelevels[this._feelevels.length - 1].FeeSetupID
                    }`
                );
                row.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                this.IsAddClicked = false;
            }
        }, 1000);

        if (this.contractChanged == true && this._feelevels.length > 0) {
            this.selectedContract = this._feelevels[0];
            this.onContractSelected({data: this.selectedContract});
            this.handleOnOpen([0, 1]);
            this.contractChanged = false;
        }

        this.IsLoading = false;
    }
    get feeLevels(): Array<FeeLevel> {
        return this._feelevels;
    }

    private FeeHistorySubject = new ReplaySubject<
        Array<fromDataServices.FeeHistory.FeeHistory>
    >(1);
    private _feehistory: Array<fromDataServices.FeeHistory.FeeHistory>;
    @Input() set feeHistory(
        value: Array<fromDataServices.FeeHistory.FeeHistory>
    ) {
        this._feehistory = value;
        if (this._feehistory.some(x => x.ChargeNumber != null) == true) {
            this.log.verbose('there are charge numbers: hist');
            this.AreHistCNs = true;
            this.histColSpan = 2;
        } else {
            this.log.verbose('there are not charge numbers: hist');
            this.AreHistCNs = false;
            this.histColSpan = 1;
        }
        this.FeeHistorySubject.next(value);

        this.hist_cnFilterSelectItem = value.map(x => ({
            value: x.CNListID,
            label: x.ChargeNumber
        }));
        this.hist_cnFilterSelectItem = this.hist_cnFilterSelectItem.filter(
            (v, i, a) => a.findIndex(t => t.label === v.label) === i
        );

        this.hist_ctFilterSelectItem = value.map(x => ({
            value: x.ContractType,
            label: x.ContractType
        }));
        this.hist_ctFilterSelectItem = this.hist_ctFilterSelectItem.filter(
            (v, i, a) => a.findIndex(t => t.label === v.label) === i
        );
    }
    get feeHistory(): Array<fromDataServices.FeeHistory.FeeHistory> {
        return this._feehistory;
    }

    private FeeOnGASubject = new ReplaySubject<
        Array<fromDataServices.FeeOnGA.FeeOnGA>
    >(1);
    private _feeonga: Array<fromDataServices.FeeOnGA.FeeOnGA>;
    @Input() set feeOnGA(value: Array<fromDataServices.FeeOnGA.FeeOnGA>) {
        this._feeonga = value;
        this.FeeOnGASubject.next(value);

        this.feeOnGASelectItem = value.map(x => ({
            value: x.FeeonGAtype,
            label: x.FeeonGAdescription
        }));
        this.feeOnGASelectItem = this.feeOnGASelectItem.filter(
            (v, i, a) => a.findIndex(t => t.label === v.label) === i
        );
    }
    get feeOnGA(): Array<fromDataServices.FeeOnGA.FeeOnGA> {
        return this._feeonga;
    }

    private ContractsSubject = new ReplaySubject<
        Array<fromDataServices.Contract.Contract>
    >(1);
    private _contracts: Array<fromDataServices.Contract.Contract>;
    @Input() set contracts(value: Array<fromDataServices.Contract.Contract>) {
        if (value && value.length > 0) {

            if (this.activeOnly == false) {
                value = value.filter(x => x.IsActive == true);
            }
            this._contracts = value;
            this.ContractsSubject.next(value);
            this.loadContractsSelectItem = value.map(
                x => ({
                    value: x.ContractListID,
                    label: x.ContractDesc
                })
            );
        }
    }
    get contracts(): Array<fromDataServices.Contract.Contract> {
        return this._contracts;
    }

    private ContractTypesSubject = new ReplaySubject<
        Array<fromLookups.IContractType>
    >(1);
    private _contracttypes: Array<fromLookups.IContractType>;
    @Input() set contractTypes(value: Array<fromLookups.IContractType>) {
        if (value && value.length > 0) {
            this._contracttypes = value;
            this.ContractTypesSubject.next(value);
            this.contractTypesSelectItem = value.map(x => ({
                value: x.ContractType,
                label: x.ContractTypeName
            }));
            if (
                this._contracttypes.some(x => x.ContractType == 'unknown') ==
                true
            ) {
                this.contractTypesSelectItem =
                    this.contractTypesSelectItem.filter(
                        x => x.value != 'unknown'
                    );
            }
        }
    }
    get contractTypes(): Array<fromLookups.IContractType> {
        return this._contracttypes;
    }

    private ChargeNumbersSubject = new ReplaySubject<
        Array<IChargeNumberManagement>
    >(1);
    private _chargenumbers: Array<IChargeNumberManagement>;
    @Input() set chargeNumbers(value: Array<IChargeNumberManagement>) {
        if (value && value.length > 0) {
            this._chargenumbers = value;
            this.ChargeNumbersSubject.next(value);
            const filteredCNs = this._chargenumbers.filter(
                x => x.ContractType == this.selectedContractType
            );
            const filteredCNsUnique = [];
            let index;
            if (filteredCNs.length > 0) {
                filteredCNs.forEach(cn => {
                    index = this.feeLevels.findIndex(
                        fee => fee.CNListID == cn.CNListID
                    );
                    if (index == -1) {
                        filteredCNsUnique.push(cn);
                    }
                });
            }

            if (filteredCNsUnique.length > 0) {
                this.chargeNumberDDPlaceholder = 'Charge Number';
            } else {
                this.chargeNumberDDPlaceholder = 'All Charge Numbers Assigned';
            }

            this.chargeNumbersSelectItem = filteredCNsUnique.map(x => ({
                value: x.CNListID,
                label: x.FullName
            }));
            // this.chargeNumbersSelectItem = value.map(x => ({
            //     value: x.CNListID,
            //     label: x.FullName
            // }));
        }
    }
    get chargeNumbers(): Array<IChargeNumberManagement> {
        return this._chargenumbers;
    }

    chargeNumberDDPlaceholder = 'Charge Number';

    @Input() public process: Process;
    @Input() public userInfo: fromUser.IUserInfo;

    public editing: FeeLevel = {} as FeeLevel;
    clonedFeeLevels: { [i: string]: FeeLevel } = {};

    clonedFeeHistory: { [i: string]: fromDataServices.FeeHistory.FeeHistory } =
        {};
    public histEditing: fromDataServices.FeeHistory.FeeHistory =
        {} as fromDataServices.FeeHistory.FeeHistory;

    active = true;

    @Output() LoadFeeLevels = new ReplaySubject<any>(1);
    @Output() LoadActiveInactiveFeeLevel = new ReplaySubject<any>(1);
    @Output() SaveFeeLevels = new ReplaySubject<any>(1);
    @Output() DeleteFeeLevel = new ReplaySubject<FeeLevel>(1);
    @Output() LoadContracts = new ReplaySubject<any>(1);
    @Output() LoadChargeNumbers = new ReplaySubject<any>(1);
    @Output() LoadFeeHistory = new ReplaySubject<any>(1);
    @Output() SaveFeeHistory = new ReplaySubject<any>(1);

    loadContractsSelectItem: SelectItem[];
    contractsSelectItem: SelectItem[];
    contractTypesSelectItem: SelectItem[];
    chargeNumbersSelectItem: SelectItem[];
    cFilterSelectItem: SelectItem[];
    cnFilterSelectItem: SelectItem[];
    ctFilterSelectItem: SelectItem[];
    hist_cnFilterSelectItem: SelectItem[];
    hist_ctFilterSelectItem: SelectItem[];
    feeOnGASelectItem: SelectItem[];

    @ViewChild(Table, { static: true }) ContractTable: Table;

    addFormGroup: UntypedFormGroup;
    cFilterFormGroup: UntypedFormGroup;
    cnFilterFormGroup: UntypedFormGroup;
    ctFilterFormGroup: UntypedFormGroup;
    hist_cnFilterFormGroup: UntypedFormGroup;
    hist_ctFilterFormGroup: UntypedFormGroup;
    histFormGroup: UntypedFormGroup;

    withholding = true;
    hist_withholding = true;

    CPFF_LOE: boolean;
    hist_CPFF_LOE: boolean;
    IsHistTableSelected = false;

    selectedContractType: string;
    selectedContracts: any[] = [];
    selectedChargeNumbers: any[] = [];

    selectedContract: FeeLevel;

    AreHistCNs: boolean;
    AreCns: boolean;

    IsAddClicked = false;

    accordionSelected = false;

    histColSpan = 2;
    colspan = 4;

    @ViewChild(Table, { static: true })
    FeeLevelTable: Table;
    @ViewChild(Table, { static: true })
    FeeHistoryTable: Table;

    filteredContracts: Array<fromDataServices.Contract.Contract> = [];

    moment: any;

    IsLoading: boolean;

    feeHistoryHeader = 'Fee History';

    histStartDate: any;
    histEndDate: any;

    cols: any[];

    showFeeAmtDialog = false;

    feeAmtFocused = false;

    elements: HTMLCollection;

    activeState = [true, false];

    activeOnly = false;

    contractList = [];

    showDefinedFeeDialog = false;

    public currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    public tabHeight = '54vh';
    public percentFormatter(num) {
        return Number(num / 100).toLocaleString(undefined, {
            style: 'percent',
            minimumFractionDigits: 2
        });
    }

    IsColumnFrozen = false;

    constructor(@Inject(LoggingService) private log: LoggingService,  protected cdRef: ChangeDetectorRef) {
        super();
        this.addFormGroup = new UntypedFormGroup({
            ContractType: new UntypedFormControl(null),
            Contract: new UntypedFormControl(null),
            ChargeNumber: new UntypedFormControl(null),
            FeePercent: new UntypedFormControl(null),
            FeeAmount: new UntypedFormControl(null),
            FeeHours: new UntypedFormControl(null),
            ed: new UntypedFormControl(null)
        });
        this.cFilterFormGroup = new UntypedFormGroup({
            c: new UntypedFormControl(null)
        });
        this.cnFilterFormGroup = new UntypedFormGroup({
            cn: new UntypedFormControl(null)
        });
        this.ctFilterFormGroup = new UntypedFormGroup({
            ct: new UntypedFormControl(null)
        });
        this.hist_cnFilterFormGroup = new UntypedFormGroup({
            cn: new UntypedFormControl(null)
        });
        this.hist_ctFilterFormGroup = new UntypedFormGroup({
            ct: new UntypedFormControl(null)
        });
        this.histFormGroup = new UntypedFormGroup({
            dateRange: new UntypedFormControl(null),
            clearFilters: new UntypedFormControl(null),
            showHide: new UntypedFormControl(null)
        });
        this.moment = moment;
    }

    ngOnInit(): void {
        this.today = new Date();
        this.minDate = new Date('01/01/1970');
        this.cols = [
            { field: 'ContractDesc', header: 'Contract' },
            { field: 'ChargeNumber', header: 'Charge Number' },
            { field: 'ContractType', header: 'Contract Type' },
            { field: 'EffectiveDate', header: 'Effective Date' },
            { field: 'FeePercentage', header: 'Fee %' },
            { field: 'FeeAmount', header: 'Fee Amount' },
            { field: 'EstHours', header: 'Est. Hours' },
            { field: 'FeeBilledCumulative', header: 'Fee Invoiced' },
            { field: 'FeeRetainCumulative', header: 'Fee Withheld' },
            {
                field: 'FeeRetainFull_FeeAmount',
                header: 'Start at Fee Invoiced'
            },
            { field: 'FeeRetainPercentStartDate', header: 'Start Date' },
            { field: 'FeeRetainPercent', header: 'Fee % Withheld' },
            {
                field: 'FeeRetainStop_FeeAmount',
                header: 'Stop at Fee Invoiced'
            },
            {
                field: 'FeeRetainStop_RetainAmount',
                header: 'Stop at Fee Withheld'
            }
        ];
        // var table = document.getElementById("FeeLevelTable");
        // table.style.maxHeight = '35vh';
        this.setupSubscriptions();
        this.handleOnOpen([0]);
    }

    ngAfterViewInit(): void {
        this.IsColumnFrozen = true;
        if (this.userInfo != null) {
            this.histFormGroup.controls['dateRange'].patchValue([
                new Date(this.userInfo.PrevPayPeriodStart),
                new Date(this.userInfo.PrevPayPeriodEnd)
            ]);
        }
        setTimeout(() => {
            this.onActiveIndexChange([0, 1]);
        }, 0);

        //this.elements = document.getElementsByClassName('p-header-cell');
    }

    ngOnDestroy(): void {
        this.active = false;
    }

    setupSubscriptions() {
        this.log.verbose({
            type: 'FeeLevelPresenterComponent:setupSubscriptions'
        });

        this.addFormGroup.controls['ContractType'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.addFormGroup.controls['Contract'].reset();
                    this.addFormGroup.controls['ChargeNumber'].reset();
                    if (value == 'CPFF/LOE') {
                        this.addFormGroup.controls['FeeHours'].enable();
                        this.addFormGroup.controls['FeePercent'].disable();
                    } else {
                        this.addFormGroup.controls['FeeHours'].disable();
                        this.addFormGroup.controls['FeePercent'].enable();
                    }
                    this.filteredContracts = this.contracts.filter(
                        x =>
                            x.ContractType == value || x.ContractType == 'mixed'
                    );
                    this.filteredContracts = this.filteredContracts.filter(x => x.IsActive == true);
                    this.contractsSelectItem = this.filteredContracts.map(
                        x => ({
                            value: x.ContractListID,
                            label: x.ContractDesc
                        })
                    );
                    this.selectedContractType = value;
                }
            });
        this.addFormGroup.controls['Contract'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.addFormGroup.controls['ChargeNumber'].reset();
                    this.selectedContracts = [];
                    if (value.length != 0) {
                        this.LoadChargeNumbers.next(value);
                    }
                    value.forEach(val => {
                        this.selectedContracts.push({
                            contractlistid: this.contracts.find(
                                x => x.ContractListID == val
                            ).ContractListID,
                            contractdesc: this.contracts.find(
                                x => x.ContractListID == val
                            ).ContractDesc,
                            isactive: this.contracts.find(
                                x => x.ContractListID == val
                            ).IsActive
                        });
                    });
                    if (value.length > 1) {
                        this.addFormGroup.controls['ChargeNumber'].disable();
                        this.chargeNumberDDPlaceholder =
                            '[ Disabled ] multiple contracts selected';
                    } else {
                        this.chargeNumberDDPlaceholder = 'Charge Numbers';
                        this.addFormGroup.controls['ChargeNumber'].enable();
                    }
                }
            });
        this.addFormGroup.controls['ChargeNumber'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.selectedChargeNumbers = [];
                    value.forEach(val => {
                        this.selectedChargeNumbers.push({
                            CNListID: this.chargeNumbers.find(
                                x => x.CNListID == val
                            ).CNListID,
                            FullName: this.chargeNumbers.find(
                                x => x.CNListID == val
                            ).FullName
                        });
                    });
                }
            });
        this.addFormGroup.controls['FeePercent'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                }
            });
        this.addFormGroup.controls['FeeAmount'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                }
            });
        this.addFormGroup.controls['FeeHours'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                }
            });
        this.cFilterFormGroup.controls['c'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                }
            });
        this.cnFilterFormGroup.controls['cn'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                }
            });
        this.ctFilterFormGroup.controls['ct'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                }
            });
        this.histFormGroup.controls['dateRange'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (
                    value[0] != null &&
                    value[1] != null &&
                    this.selectedContract != null
                ) {
                    this.histStartDate = value[0];
                    this.histEndDate = value[1];
                    this.LoadFeeHistory.next({
                        ContractListID: this.selectedContract.ContractListID,
                        StartDate: value[0],
                        EndDate: value[1]
                    });
                }
            });
    }

    onFeeAmtFocus(event) {
        if (event) {
            this.feeAmtFocused = true;
        }
    }

    onFeeAmtUnfocus(event) {
        if (event) {
            this.feeAmtFocused = false;
        }
    }

    feeAmtDialogAction(action) {
        if (action == 'YES') {
            this.LoadFeeLevels.next({
                EffectiveDate: this.addFormGroup.controls['ed'].value,
                ContractList: this.selectedContracts,
                CNList: this.selectedChargeNumbers,
                FeePercentage: this.addFormGroup.controls['FeePercent'].value,
                FeeAmount: this.addFormGroup.controls['FeeAmount'].value,
                EstHours: this.addFormGroup.controls['FeeHours'].value,
                FeeRetainFull_FeeAmount:
                    this.addFormGroup.controls['FeeAmount'].value
            });

            this.addFormGroup.controls['ContractType'].reset();
            this.addFormGroup.controls['Contract'].reset();
            this.addFormGroup.controls['ChargeNumber'].reset();
            this.addFormGroup.controls['FeePercent'].reset();
            this.addFormGroup.controls['FeeAmount'].reset();
            this.addFormGroup.controls['FeeHours'].reset();
            this.addFormGroup.controls['ed'].reset();
            this.showFeeAmtDialog = false;
        } else {
            this.LoadFeeLevels.next({
                EffectiveDate: this.addFormGroup.controls['ed'].value,
                ContractList: this.selectedContracts,
                CNList: this.selectedChargeNumbers,
                FeePercentage: this.addFormGroup.controls['FeePercent'].value,
                FeeAmount: this.addFormGroup.controls['FeeAmount'].value,
                EstHours: this.addFormGroup.controls['FeeHours'].value
            });

            this.addFormGroup.controls['ContractType'].reset();
            this.addFormGroup.controls['Contract'].reset();
            this.addFormGroup.controls['ChargeNumber'].reset();
            this.addFormGroup.controls['FeePercent'].reset();
            this.addFormGroup.controls['FeeAmount'].reset();
            this.addFormGroup.controls['FeeHours'].reset();
            this.addFormGroup.controls['ed'].reset();
            this.showFeeAmtDialog = false;
        }
    }

    onCheckboxChange(event) {
        //this.IsLoading = true;
        // this.LoadFeeLevels.next({
        //     ContractList: this.contractList.length > 0 ? this.contractList : [],
        //     ActiveOnly: !this.activeOnly
        // });
        this.LoadActiveInactiveFeeLevel.next(!event.checked);
    }

    addClicked() {
        this.IsAddClicked = true;
        if (this.addFormGroup.controls['FeeAmount'].value != null) {
            this.showDefinedFeeDialog = false;
            this.showFeeAmtDialog = true;
        } else {
            this.LoadFeeLevels.next({
                EffectiveDate: this.addFormGroup.controls['ed'].value,
                ContractList: this.selectedContracts,
                CNList: this.selectedChargeNumbers,
                FeePercentage: this.addFormGroup.controls['FeePercent'].value,
                FeeAmount: this.addFormGroup.controls['FeeAmount'].value,
                EstHours: this.addFormGroup.controls['FeeHours'].value
            });

            this.addFormGroup.controls['ContractType'].reset();
            this.addFormGroup.controls['Contract'].reset();
            this.addFormGroup.controls['ChargeNumber'].reset();
            this.addFormGroup.controls['FeePercent'].reset();
            this.addFormGroup.controls['FeeAmount'].reset();
            this.addFormGroup.controls['FeeHours'].reset();
            this.addFormGroup.controls['ed'].reset();
        }

        // var row = document.getElementById(
        //     `row-${this.feeLevels[this.feeLevels.length - 1].FeeSetupID}`
        // );
        // row.scrollIntoView({
        //     behavior: 'smooth',
        //     block: 'center',
        //     inline: 'nearest'
        // });
    }

    findFeeOnGA(rowData: FeeLevel): string {
        if (rowData.FeeonGA != null) {
            const match = this.feeOnGA.find(
                x => x.FeeonGAtype === rowData.FeeonGA
            );
            return match.FeeonGAdescription;
        } else {
            return '';
        }
    }

    ////////////////////////// FEE LEVEL EDIT FUNCTIONS ////////////////////////////////
    onEditInit($event: { data: FeeLevel }) {
        this.editing = { ...$event.data };
    }

    onRowEditInit(rowData: FeeLevel) {
        this.clonedFeeLevels[rowData.FeeSetupID] = { ...rowData };
        this.editing = rowData;
        this.CPFF_LOE = null;
        if (rowData.ContractType == 'CPFF/LOE') {
            this.CPFF_LOE = true;
        } else {
            this.CPFF_LOE = false;
        }
        this.log.verbose('onRowEditInit');
    }

    onRowEditSave(rowData: FeeLevel) {
        this.SaveFeeLevels.next(rowData);
        delete this.clonedFeeLevels[rowData.FeeSetupID];
        delete this.editing;
        this.log.verbose('onRowEditSave');
    }

    onRowEditCancel(item: FeeLevel) {
        const index = this.feeLevels.findIndex(
            x => x.FeeSetupID === item.FeeSetupID
        );
        if (index >= 0) {
            this.feeLevels.splice(
                index,
                1,
                this.clonedFeeLevels[item.FeeSetupID]
            );
        }
        this.feeLevels = [...this.feeLevels];
        delete this.clonedFeeLevels[item.FeeSetupID];
        delete this.editing;
        this.log.verbose('onRowEditCancel');
    }

    DeleteFee(rowData: FeeLevel) {
        this.DeleteFeeLevel.next(rowData);
    }

    onContractSelected($event) {

        if (this.oldSelectedContract && $event.data.ContractListID == this.oldSelectedContract.ContractListID) {
            return;
        }
        this.feeHistoryHeader = `Fee History for ${$event.data.ContractDesc}`;
        this.activeState[1] = true;
        this.accordionSelected = true;

        if (this.userInfo != null) {
            if (this.histStartDate != null && this.histEndDate != null) {
                this.LoadFeeHistory.next({
                    ContractListID: $event.data.ContractListID,
                    StartDate: this.histStartDate,
                    EndDate: this.histEndDate
                });
            } else {
                this.LoadFeeHistory.next({
                    ContractListID: $event.data.ContractListID,
                    StartDate: this.userInfo.PrevPayPeriodStart,
                    EndDate: this.userInfo.PrevPayPeriodEnd
                });
            }
        } else {
            if (this.histStartDate != null && this.histEndDate != null) {
                this.LoadFeeHistory.next({
                    ContractListID: $event.data.ContractListID,
                    StartDate: this.histStartDate,
                    EndDate: this.histEndDate
                });
            } else {
                this.LoadFeeHistory.next({
                    ContractListID: $event.data.ContractListID,
                    StartDate: null,
                    EndDate: null
                });
            }
        }
        this.oldSelectedContract = $event.data;
    }

    clearTableFilters() {
        this.cFilterFormGroup.controls['c'].reset();
        this.cnFilterFormGroup.controls['cn'].reset();
        this.ctFilterFormGroup.controls['ct'].reset();
        this.FeeLevelTable.clear();
    }

    showHideWithholding() {
        if (this.withholding == true) {
            this.withholding = false;
        } else {
            this.withholding = true;
        }
    }
    //////////////////////////////////////////////////////////////////////////////////

    /////////////////////////// FEE HISTORY EDIT FUNCTIONS ///////////////////////////
    onHistEditInit($event: { data: fromDataServices.FeeHistory.FeeHistory }) {
        this.histEditing = { ...$event.data };
    }

    onHistRowEditInit(rowData: fromDataServices.FeeHistory.FeeHistory) {
        this.clonedFeeHistory[rowData.id] = { ...rowData };
        this.histEditing = rowData;
        this.hist_CPFF_LOE = null;
        if (rowData.ContractType == 'CPFF/LOE') {
            this.hist_CPFF_LOE = true;
        } else {
            this.hist_CPFF_LOE = false;
        }
        this.log.verbose('onHistRowEditInit');
    }

    onHistRowEditSave(rowData: fromDataServices.FeeHistory.FeeHistory) {
        this.SaveFeeHistory.next(rowData);
        delete this.clonedFeeHistory[rowData.id];
        delete this.histEditing;
        this.log.verbose('onHistRowEditSave');
    }

    onHistRowEditCancel(item: fromDataServices.FeeHistory.FeeHistory) {
        delete this.clonedFeeHistory[item.id];
        delete this.histEditing;
        this.log.verbose('onHistRowEditCancel');
    }

    clearHistoryTableFilters() {
        this.hist_cnFilterFormGroup.controls['cn'].reset();
        this.hist_ctFilterFormGroup.controls['ct'].reset();
        this.FeeHistoryTable.clear();
    }

    showHideHistoryWithholding() {
        if (this.hist_withholding == true) {
            this.hist_withholding = false;
        } else {
            this.hist_withholding = true;
        }
    }

    onDateRangeSelected() {}

    onActiveIndexChange($event: number[]) {
        // this.log.verbose({
        //     type: 'FeeLevelPresenterComponent:onActiveIndexChange',
        //     $event
        // });
        // let baseHeight = 58;
        // if ($event && $event.includes(0)) {
        //     baseHeight -= 8;
        //     $event.splice($event.indexOf(0), 1);
        // }
        // this.tabHeight = `${
        //     (baseHeight - 8 * ($event.length - 1)) /
        //     ($event && $event.length ? $event.length : 1)
        // }vh`;
        // this.log.verbose({
        //     type: 'FeeLevelPresenterComponent:onActiveIndexChange',
        //     tabHeight: this.tabHeight
        // });
    }

    handleOnOpen($event) {
        // Calculate heights more conservatively to prevent cutting off
        // Account for accordion headers, toolbar, padding, and browser chrome
        const availableViewportHeight = 80; // Use 80vh instead of 100vh for safety
        const accordionHeaderHeight = 8; // Approximate height for accordion headers
        const toolbarHeight = 6; // Height for toolbar elements
        const paddingAndMargins = 4; // Additional space for padding/margins
        const scrollbarHeight = 3; // Extra space for horizontal scrollbar

        let containerHeight = 30; // Default conservative height in vh

        if ($event.length === 1) {
            // Single accordion open - can use more space
            containerHeight = availableViewportHeight - accordionHeaderHeight - toolbarHeight - paddingAndMargins - scrollbarHeight;
            containerHeight = Math.min(containerHeight, 65); // Cap at 65vh to ensure scrollbar visibility
        } else if ($event.length === 2) {
            // Both accordions open - split available space
            const totalOverhead = (accordionHeaderHeight * 2) + (toolbarHeight * 2) + (paddingAndMargins * 2) + (scrollbarHeight * 2);
            containerHeight = (availableViewportHeight - totalOverhead) / 1.5;
            containerHeight = Math.min(containerHeight, 30); // Cap at 30vh per accordion to ensure scrollbar visibility
        }

        // Ensure minimum height that includes scrollbar space
        containerHeight = Math.max(containerHeight, 18);

        if (this.activeState[0]) {
            this.feeLevelContainerHeight = `${containerHeight}vh`;
            this.feeLevelTabHeight = `${containerHeight - 5}vh`; // Reserve more space for padding/toolbar/scrollbar
        }
        if (this.activeState[1]) {
            this.feeHistContainerHeight = `${containerHeight}vh`;
            this.feeHistTabHeight = `${containerHeight - 5}vh`; // Reserve more space for padding/toolbar/scrollbar
        }

        this.log.verbose({
            type: 'FeeLevelComponent:handleOnOpen',
            $event,
            containerHeight,
            scrollHeight: this.FeeLevelTable?.scrollHeight
        });
        this.cdRef.detectChanges();
    }

    onChangeContracts($event) {
        this.contractList = [];
        $event.value.forEach(x => {
            if (this.contracts.findIndex(con => con.ContractListID == x) != -1) {
                var contractObj = this.contracts.find(con => con.ContractListID == x);
                this.contractList.push(contractObj);
            }
        });
        this.LoadFeeLevels.next({
            ContractList: this.contractList,
            ActiveOnly: !this.activeOnly
        });

        this.contractChanged = true;
    }
    // onColumnResize($event) {

    //     var numOfFrozenCols = 4;
    //     var table = document.querySelector('table');
    //     columnResize($event, numOfFrozenCols, table);
    // }
}
